import Vue from "vue";
import Vuex from "vuex";

import donations from "@/store/donations";
import quizStore from "@/store/quizStore";
import teamStore from "@/store/teamStore";
import presetStore from "@/store/presetStore";
import chatStore from "@/store/chatStore";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userName: "",
    userID: 0,
    userRole: 0,
    viewerInfo: {},
    bootstrapScreenSize: "none",
    frontEndVersion: 0
  },
  mutations: {
    setUserID(state, userID) {
      state.userID = userID;
    },
    setUserName(state, username) {
      state.userName = username;
    },
    setUserRole(state, role) {
      state.userRole = role;
    },
    setViewerInfo(state, info) {
      Vue.set(state.viewerInfo, info.quizID, info.viewerCount);
    },
    setBootstrapSize(state, size) {
      state.bootstrapScreenSize = size;
    },
    setFrontEndVersion(state, version) {
      state.frontEndVersion = version;
    }
  },
  actions: {
    login({ commit }, params) {
      var role = params[1];
      var username = params[2];
      var userID = params[3];

      commit("setUserName", username);
      commit("setUserRole", role);
      commit("setUserID", userID);
    },
    setFrontEndVersion({ commit }, version) {
      commit("setFrontEndVersion", version);
    }
  },
  getters: {
    isLoggedIn: state => {
      return state.userName !== undefined && state.userName.length > 0;
    }
  },
  modules: { quizStore, donations, teamStore, presetStore, chatStore }
});
